import { Box, Button, Fab, Grid, Stack, TextField, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { AlertMessage } from "../messages/AlertMessage";
import { useLocation, useNavigate } from "react-router";
import { FryerEntry } from "./FryerEntry";
import { useAuth } from "../auth/AuthContext";
import { NoAccessModal } from "../NoAccessModal";
import AddIcon from '@mui/icons-material/Add';

const Fryer = () =>
{  
    const { state } = useLocation();
    const [fryers, setFryers] = useState([]);
    const [open, setOpen] = useState(false);

    const auth = useAuth()?.auth;

    let navigate = useNavigate();

    const loadAllFryers = () => {
        const requestOptions = {
            method: 'GET'
        };
        
        fetch('/api/public/fryers', requestOptions)
        .then(r => r.json())
        .then(res => setFryers(res))
        .catch(err => console.error(err));
    };
    
    useEffect(() => {
        loadAllFryers();
    }, []);

    const handleChangeSearch = (event) => {
        const requestOptions = {
            method: 'GET'
        };
        const val = event.target.value;
        if(val === ''){
            loadAllFryers();
        }else{
            fetch('/api/public/search_fryer?searchString='+val, requestOptions)
            .then(r => r.json())
            .then(res => {
                setFryers(res);
            })
            .catch(err => console.error(err));
        }
        
    };

    const handleAddFryer = () => {
        if(auth) {
            navigate('/fryer/add');
        } else {
            setOpen(true);
        }
    }

    return(
        <Box sx={{flexGrow: 1, marginTop: '10px !important'}}>
           <Box sx={{ overflow: "auto" }}>
              <Box sx={{ width: "100%", boxSizing: 'border-box', display: "table", tableLayout: "fixed" }}>
                    <AlertMessage severity={'success'} message={state?.message} />
                    <Stack direction="row" spacing={2} sx={{ flexGrow: 1, margin: '20px', alignItems: 'center' }}>
                        <Typography variant="h6" component="div">
                        Fryer
                        </Typography>
                        <Fab onClick={() => handleAddFryer()} size="medium" color="primary" aria-label="add">
                        <AddIcon />
                        </Fab>
                    </Stack>
                    <TextField label="Suche" onChange={(event) => handleChangeSearch(event)}/>
                    <Grid
                        container
                        direction="row"
                        sx={{
                            marginTop: '20px',
                            alignItems: "stretch",
                        }} 
                        spacing={4}
                    >
                        {fryers?.length === 0 && 
                        (<Box sx={{ marginTop: '20px !important', marginBottom: '20px !important' }}>
                            <Typography sx={{marginLeft: '20px !important'}} variant="body2">
                            Leider konnten wir keine Einträge finden, die deinem Fryer entsprechen. 
                            Versuche es mit einem anderen Suchbegriff oder erstelle selbst einen neuen Eintrag.
                            </Typography>
                            <Button className="custom-button-root" href="/fryer/add">Neuen Eintrag erstellen</Button>
                        </Box>)}
                        {fryers.map(f => <FryerEntry
                            id={f?.id}
                            name={f?.name}
                            hersteller={f?.hersteller} 
                            handleChangeSearch={handleChangeSearch}
                            auth={auth}
                        />)}
                    </Grid>
                </Box>
            </Box>
            <NoAccessModal open={open} setOpen={setOpen}/>
        </Box>
    );
};

export default Fryer;